import LatestLoans from "./LatestLoans";

export default LatestLoans;
